import {TranslateService} from '@ngx-translate/core';

export const enum CsvType {
  Prescription = 'prescription',
  TherapyPlan = 'therapy-plan',
  Patient = 'patient',
  Appointment = 'appointment',
}

export const csvTypeMap = (translate: TranslateService, locale: string) => {
  return {
    [CsvType.Appointment]: {
      key: CsvType.Appointment,
      name: translate.instant('appointmentLbl'),
      url: `assets/bulk-upload-options/appointment-${locale}.csv`,
    },
    [CsvType.Prescription]: {
      key: CsvType.Prescription,
      name: translate.instant('prescriptionsLbl'),
      url: `assets/bulk-upload-options/prescription-${locale}.csv`,
    },
    [CsvType.TherapyPlan]: {
      key: CsvType.TherapyPlan,
      name: translate.instant('treatmentPlanLbl'),
      url: `assets/bulk-upload-options/therapy-${locale}.csv`,
    },
    [CsvType.Patient]: {
      key: CsvType.Patient,
      name: translate.instant('patientsLbl'),
      url: `assets/bulk-upload-options/patient-${locale}.csv`,
    },
  };
};
